<template>
    <SwapMenu2 :swapid="swapid" period="None" title="Report Data" margin="1">
      <template v-slot:menu>
        <li><a v-if="interval == 0" 
            class="dropdown-item" @click=start_interval()>Save</a></li>
      </template>
    </SwapMenu2>

    <div class="table-responsive" style="height:640px">
        <table class="table table-striped table-bordered font-custom">
            <thead>
                <tr>
                    <th v-for="h in header" :key=h>
                        {{h}}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(data, index) in graphtab" :key="data[0]">
                    <td v-for="col in data" :key="col" :style="getstyle(index)">
                        {{ col }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>    
</template>

<style scoped>
.font-custom {
    font-size : 10pt ;
    text-align: left ;
}
.colpad {
    padding: 0.1rem !important ;
    font-size: 10pt ;
    text-align : left ;
    white-space: nowrap ;
    overflow : auto ;
}
.divstyle {
    font-size : 10pt ;
    max-height: auto ;
    overflow-y: auto;
    margin-top: 0px ;
}
.aligncenter {
    text-align: center ;
}
</style>

<script>
import SwapMenu2 from './SwapMenu2.vue' 

export default {
  name: 'ReportData',
  components: {
      SwapMenu2
  },
  props: {
    swapid : String,
    screensize : String
  },
  data() {
    return {
        header : [ "X", "Y", "X", "Y" ],
        colortab : [],
        graphtab : [ [ 0, 0, 0, 0 ] ],
        info : [ ],
    }
  },
  computed : {
  },
  methods : {
      getstyle(index) {
        if (index < this.colortab.length)
            return "background: " + this.colortab[index] ;
        return "" ;
      },
      writedata (data, colortab) {
        this.info = data.info;
        this.colortab = colortab ;
        let tab = data.tab ;
        let len = tab.length ;

        // split table by 2
        let newtab = [] ;
        if ( ! colortab  || colortab.length == 0) {
          let x = parseInt(len / 2) ;
          x += len % 2 ;
          for (let i = 0 ; i < x ; i++) 
             newtab[i] = [ tab[i][0], tab[i][1], 0, 0 ] ;

          for (let i = x; i < tab.length ; i++) {
             newtab[i-x][2] = tab[i][0] ;
             newtab[i-x][3] = tab[i][1] ;
          }
          this.header = [ "X", "Y", "X", "Y" ] ;
        }
        else {
          this.header = [ "X", "Y", "%", "COLOR" ] ;
          let totval = 0 ;
          for (let e of tab) { 
             totval += parseFloat(e[1])
          }
          for (let i = 0 ; i < tab.length ; i++) {
            let val = Math.round(parseFloat(tab[i][1])) ;
            let percent = Math.round (val * 10000/ totval ) / 100 ;
            newtab[i] = [ tab[i][0],val, percent, colortab[i] ] ;
          }
        }
        this.graphtab = newtab ;
     }
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>


